import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * RoleBasedRoute component - Protects routes based on user roles
 * @param {Object} props
 * @param {React.ReactNode} props.children - The component to render if access is granted
 * @param {Function} props.hasAccess - Function that returns true if user has access
 * @param {string} props.redirectTo - Path to redirect to if access is denied (default: /dashboard)
 */
export default function RoleBasedRoute({ children, hasAccess, redirectTo = '/dashboard' }) {
    const { loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!hasAccess()) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}
